import { Maybe } from 'maybeasy';
import { T, TPlainTextKey } from '../../../../../../../Translations';
import { observer } from 'mobx-react';
import { emptyFragment } from '../../../../../../../EmptyFragment';

interface Props {
  error: Maybe<TPlainTextKey>;
}

function ErrorMessage({ error }: Props) {
  return error
    .map((error) => (
      <div
        className="p-4 mb-4 mt-4 text-sm 
        text-red-800 
        rounded-lg bg-red-50 
        dark:bg-gray-800 dark:text-red-400"
        role="alert"
      >
        <span className="font-medium">
          <T kind={error} />
        </span>
      </div>
    ))
    .getOrElse(emptyFragment);
}

export default observer(ErrorMessage);
